/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { TurJob } from '../../models/tur-job';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAllJobs$Params {}

export function getAllJobs(
  http: HttpClient,
  rootUrl: string,
  params?: GetAllJobs$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TurJob>>> {
  const rb = new RequestBuilder(rootUrl, getAllJobs.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TurJob>>;
    }),
  );
}

getAllJobs.PATH = '/manage/job';
